import { z } from 'zod'

export const objectiveSchema = z.object({
  id: z.string(),
  course_id: z.string().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  target_date: z.string().nullable(),
  status: z.enum(['pending', 'completed', 'abandoned']),
  completed_at: z.string().nullable(),
  created_at: z.string(),
})

export type Objective = z.infer<typeof objectiveSchema>

export const createObjectiveSchema = z.object({
  title: z.string().min(1, 'objectives.errors.title_required').max(100, 'objectives.errors.title_max'),
  description: z.string().max(500, 'Maximum 500 caracteres').optional().or(z.literal('')),
  target_date: z.string().optional().or(z.literal('')),
  course_id: z.string().uuid().optional().or(z.literal('')),
})

export type CreateObjectiveFormData = z.infer<typeof createObjectiveSchema>

export const updateObjectiveSchema = z.object({
  title: z.string().min(1).max(100).optional(),
  description: z.string().max(500).optional().or(z.literal('')),
  target_date: z.string().optional().or(z.literal('')),
  status: z.enum(['pending', 'completed', 'abandoned']).optional(),
})

export type UpdateObjectiveData = z.infer<typeof updateObjectiveSchema>
